<template>
  <dialog :open="isOpen" class="renew-dialog" @click="closeModal">
    <div class="dialog-content text-center p-0 overflow-hidden" @click.stop>
      <div class="banner-top d-flex align-items-center justify-content-center p-4">
        <div class="icon-wrap">
          <i class="fas fa-clock text-white"></i>
        </div>
      </div>

      <div class="p-4 pt-5">
        <h3 class="font-weight-bolder text-dark mb-2">Seu plano vence em breve</h3>
        <p class="text-secondary mb-2 px-2">
          Restam <strong>{{ daysLeft }} dia(s)</strong>
          <span v-if="expirationLabel"> (até {{ expirationLabel }})</span>.
        </p>
        <p class="text-sm text-secondary mb-4 px-3">
          Renove agora para não perder a isenção da taxa de publicação.
          O novo período soma a partir da data de vencimento atual.
        </p>

        <div class="d-flex flex-column gap-2 mb-2">
          <button type="button" class="btn btn-renew mb-0" @click="renewPlan">
            Renovar plano
          </button>
          <button type="button" class="btn btn-outline-secondary mb-0" @click="closeModal">
            Lembrar depois
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "PlanRenewSoonModal",
  props: {
    isOpen: { type: Boolean, required: true },
    daysLeft: { type: Number, default: 0 },
    expirationLabel: { type: String, default: "" },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    renewPlan() {
      this.closeModal();
      this.$router.push("/plans");
    },
  },
};
</script>

<style scoped lang="scss">
.renew-dialog {
  border: none;
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.45);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.35s ease;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 440px;
  max-width: 95%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

.banner-top {
  background: linear-gradient(135deg, #8d6b2c 0%, #d4b56a 55%, #f0dfad 100%);
  height: 110px;
  width: 100%;
}

.icon-wrap {
  background: rgba(31, 27, 23, 0.25);
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.btn-renew {
  background: linear-gradient(90deg, #8d6b2c, #d4b56a 55%, #f0dfad) !important;
  color: #1f1b17 !important;
  border: none;
  font-weight: 800;
  padding: 12px;
  border-radius: 12px;
}
</style>
